import { render, staticRenderFns } from "./PlayerManagement.vue?vue&type=template&id=04f7d4f9&"
import script from "./PlayerManagement.vue?vue&type=script&lang=ts&"
export * from "./PlayerManagement.vue?vue&type=script&lang=ts&"
import style0 from "./PlayerManagement.vue?vue&type=style&index=0&id=04f7d4f9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports